// extracted by mini-css-extract-plugin
export default {"container":"SubscriptionCheckoutReturn_container__GXq3P"};